import mixpanel from "mixpanel-browser";
import { markAnalyticsReady } from "./core";

export interface AnalyticsInitConfig {
  token: string;
  enabled: boolean;
  debug: boolean;
  apiHost: string;
}

let initialized = false;

/**
 * Boots the Mixpanel SDK. Called once from index.tsx; every tracker stays a
 * no-op unless this ran (canvas-view never calls it). `navigator.webdriver`
 * skips init so Playwright traffic on PR previews is suppressed.
 *
 * Session replay options are deliberate: 100%, unmasked. Do not change.
 */
export function initAnalytics(config: AnalyticsInitConfig): void {
  if (initialized) return;
  if (!config.enabled || !config.token) return;
  if (typeof navigator !== "undefined" && navigator.webdriver) return;

  // Same posture as every core guard(): an SDK throw (blocked storage, an
  // extension, replay setup) must never crash boot — the latch stays off and
  // every tracker remains inert.
  try {
    mixpanel.init(config.token, {
      ...(config.apiHost ? { api_host: config.apiHost } : {}),
      debug: config.debug,
      track_pageview: false,
      persistence: "localStorage",
      opt_out_tracking_by_default: !config.enabled,
      record_sessions_percent: 100,
      record_mask_all_text: false,
    });
  } catch (error) {
    if (import.meta.env.DEV) {
      console.warn("analytics init failed; trackers stay inert", error);
    }
    return;
  }

  initialized = true;
  markAnalyticsReady();
}

/** vitest only — see testing.ts. */
export function resetInitForTest(): void {
  initialized = false;
}
